import { CnPopover } from './popover';
import { CnPopoverMenu } from './popover-menu';
import './styles/floating.scss';
function attachPropertiesToComponent(component, properties) {
    const ret = component;
    for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            ret[key] = properties[key];
        }
    }
    return ret;
}
const CnPopoverWithMenu = attachPropertiesToComponent(CnPopover, {
    Menu: CnPopoverMenu,
});
const CnPopoverBase = CnPopoverWithMenu;
CnPopoverWithMenu.displayName = 'CnPopover';
export { CnPopoverWithMenu as CnPopover, CnPopoverBase };
